import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import React from "react";
import KeyVal from "./KeyVal";

const NiceObjectCell = (props) => {
  const dispatch = useDispatch();
  
 

  const cellObject = props.children;

  if (cellObject) {
    return (
      <Box>
        {Object.keys(cellObject).map((fieldName) => (
          <div key={fieldName}>
            <KeyVal
              label={fieldName}
              value={cellObject[fieldName]}
              correctLabel={true}
            />
          </div>
        ))}
      </Box>
    );
  }
};

export default NiceObjectCell;
